import validate from "/usr/src/app/content/n3-spas-37ad7ca7-53c4-4402-adcc-3d048992f773/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-37ad7ca7-53c4-4402-adcc-3d048992f773/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}